import { INITIAL_URL } from '@/constants';

const BLACKLIST = new Set<string>(['/login', '/#', '/', '/candidates']);

/**
 * Returns true if the path should NOT be stored as an initial return URL.
 * Use exact-match semantics (same as the original `includes` behavior).
 */
const isBlacklisted = (path: string): boolean => BLACKLIST.has(path);

/**
 * Persists the current URL (path + optional search) into INITIAL_URL,
 * unless the path is blacklisted.
 *
 * - If `path` is not blacklisted, store `${path}${search}` (or '/' if path is empty).
 * - If `path` is blacklisted, do nothing.
 */
export const preserveUrl = (path: string, search: string): void => {
  if (isBlacklisted(path)) return;

  const safePath = path || '/';
  const url = search ? `${safePath}${search}` : safePath;

  localStorage.setItem(INITIAL_URL, url);
};
